import {getPlayerFinalWinPoints} from "./buildGameResults";

/**
 * Остался ли у игрока хоть один отряд или город
 *
 * @param {Object} player
 * @param {Object[]} units
 * @param {Object} citiesCache - города по цвету игрока
 * @returns {boolean}
 */
const checkIfPlayerHasUnitsOrCities = (player, units, citiesCache) => (
  (units || []).some((unit) => unit.ownerId === player.id)
  || (citiesCache?.[player.color] || []).length > 0
);

/**
 * Последний уцелевший игрок: все остальные уничтожены полностью — без
 * отрядов и без городов, — а у него итоговых очков (с монетами, как в итогах
 * партии) больше, чем у каждого из них. Тогда партия заканчивается в конце
 * раунда: выбывшим ни нанять отряд, ни построить город уже не на что, а
 * отставание уцелевшего ему не грозит. Без такого игрока — null.
 *
 * Партия из одного игрока под правило не подпадает — соперников у него нет.
 *
 * @param {Object[]} players - игроки после дохода конца раунда
 * @param {Object[]} units
 * @param {Object} citiesCache - города после захватов конца раунда
 * @returns {Object|null}
 */
export const findLastStandingPlayer = (players, units, citiesCache) => {
  if (!players || players.length < 2) {
    return null;
  }

  const standingPlayers = players.filter((player) => checkIfPlayerHasUnitsOrCities(player, units, citiesCache));
  if (standingPlayers.length !== 1) {
    return null;
  }

  const [survivor] = standingPlayers;
  const survivorScore = getPlayerFinalWinPoints(survivor);
  const isAhead = players.every((other) => other.id === survivor.id
    || survivorScore > getPlayerFinalWinPoints(other));

  return isAhead ? survivor : null;
};
